/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorPharmacyTypename = "PharmacyCounselorPharmacy" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorPharmacy
 */
export interface PharmacyCounselorPharmacy {
  /**
   * operator role only
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  chainAppName?: string;
  /**
   * operator role only
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  chainFqdn?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorPharmacy
   */
  chainId: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  chainName: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  email: string;
  /**
   * operator role only
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  externalId?: string;
  /**
   * operator role only
   * @type {boolean}
   * @memberof PharmacyCounselorPharmacy
   */
  hasLineOfficialAccount?: boolean;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorPharmacy
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  name: string;
  /**
   * operator and pharmacist and patient role only
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  sendFollowUpMessage?: PharmacyCounselorPharmacySendFollowUpMessageEnum;
  /**
   * operator role only
   * @type {boolean}
   * @memberof PharmacyCounselorPharmacy
   */
  usableOcrPrescription?: boolean;
  /**
   * operator role only
   * @type {boolean}
   * @memberof PharmacyCounselorPharmacy
   */
  usableScanPrescription?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorPharmacy
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorPharmacySendFollowUpMessageEnum {
  None = "none",
  Auto = "auto",
  Manual = "manual",
}

export function PharmacyCounselorPharmacyFromJSON(json: any): PharmacyCounselorPharmacy {
  return PharmacyCounselorPharmacyFromJSONTyped(json, false);
}

export function PharmacyCounselorPharmacyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorPharmacy {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorPharmacyTypename,

    chainAppName: !exists(json, "chain_app_name") ? undefined : json["chain_app_name"],
    chainFqdn: !exists(json, "chain_fqdn") ? undefined : json["chain_fqdn"],
    chainId: json["chain_id"],
    chainName: json["chain_name"],
    email: json["email"],
    externalId: !exists(json, "external_id") ? undefined : json["external_id"],
    hasLineOfficialAccount: !exists(json, "has_line_official_account") ? undefined : json["has_line_official_account"],
    id: json["id"],
    name: json["name"],
    sendFollowUpMessage: !exists(json, "send_follow_up_message") ? undefined : json["send_follow_up_message"],
    usableOcrPrescription: !exists(json, "usable_ocr_prescription") ? undefined : json["usable_ocr_prescription"],
    usableScanPrescription: !exists(json, "usable_scan_prescription") ? undefined : json["usable_scan_prescription"],
  };
}

export function PharmacyCounselorPharmacyToJSON(object?: PharmacyCounselorPharmacy | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_app_name: value.chainAppName,
    chain_fqdn: value.chainFqdn,
    chain_id: value.chainId,
    chain_name: value.chainName,
    email: value.email,
    external_id: value.externalId,
    has_line_official_account: value.hasLineOfficialAccount,
    id: value.id,
    name: value.name,
    send_follow_up_message: value.sendFollowUpMessage,
    usable_ocr_prescription: value.usableOcrPrescription,
    usable_scan_prescription: value.usableScanPrescription,
  };
}
